module.exports = __webpack_public_path__ + "img/grt.80c5821a.svg";